<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-0 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card flat min-height="100vh">
          <v-card-title class="elevation-1">
            <span v-if="$route.query.Type == 'MainBanner'"> Banner </span>
            <span v-else-if="$route.query.Type == 'SmallBanner'">
              Small Banner
            </span>
            <span v-else-if="$route.query.Type == 'ProductBanner'">
              Product Banner
            </span>
            <span v-else> Bottom Banner </span>

            <v-spacer></v-spacer>
            <v-flex md2>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="800px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="green"
                    width="100%"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider" ref="addcat">
                    <v-card-title>
                      <span class="headline">Add Banner</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              label="Banner Name"
                              v-model="offerData.name"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            v-if="$route.query.Type == 'ProductBanner'"
                          >
                            <v-autocomplete
                              item-text="varientName"
                              item-value="productId._id"
                              label="Product List"
                              v-model="offerData.productId"
                              :items="productList"
                            >
                            </v-autocomplete>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-if="$route.query.Type != 'BottomBanner'"
                          >
                            <v-autocomplete
                              v-model="offerData.categoryId"
                              :items="categoryList"
                              @change="getProduct(offerData.categoryId)"
                              :rules="[rules.required]"
                              item-text="name"
                              item-value="_id"
                              color="#B1B1B1"
                              hide-details
                              placeholder="Category"
                              label="Category"
                            ></v-autocomplete>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-if="$route.query.Type != 'BottomBanner'"
                          >
                            <v-autocomplete
                              v-model="offerData.subcategoryId"
                              :items="products"
                              item-text="name"
                              item-value="_id"
                              color="#B1B1B1"
                              clearable
                              placeholder="Sub Category"
                              label="Sub Category"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="text-left">
                            <span class="homeText">
                              Description of the banner</span
                            >
                            <div id="app" class="pt-3">
                              <vue-editor
                                v-model="offerData.description"
                              ></vue-editor>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="offerData.startingDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="offerData.startingDate"
                                  :rules="[rules.required]"
                                  label="Select Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="offerData.startingDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.menu.save(offerData.startingDate)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              :return-value.sync="offerData.endingDate"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  :rules="[rules.required]"
                                  v-model="offerData.endingDate"
                                  label="Select Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="offerData.endingDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu1 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.menu1.save(offerData.endingDate)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="offerData.startingTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="offerData.startingTime"
                                  :rules="[rules.required]"
                                  label="Starting Time"
                                  prepend-icon="mdi-clock"
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu3"
                                v-model="offerData.startingTime"
                                full-width
                                @click:minute="
                                  $refs.menu3.save(offerData.startingTime)
                                "
                              ></v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" class="pl-2">
                            <v-menu
                              ref="menu4"
                              v-model="menu4"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="offerData.endingTime"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="offerData.endingTime"
                                  :rules="[rules.required]"
                                  prepend-icon="mdi-clock"
                                  label="Ending Time"
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu4"
                                v-model="offerData.endingTime"
                                full-width
                                @click:minute="
                                  $refs.menu4.save(offerData.endingTime)
                                "
                              ></v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <ImageComp
                              @stepper="winStepper"
                              :height=" $route.query.Type == 'SmallBanner'? '3':'9'"
                              :width="$route.query.Type == 'SmallBanner'? '16':'16'"
                              :heading="'Upload Offer Image (Aspect Ratio: 16/9)'"
                              :componentType="'offerImage'"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-card-title>
          <div v-if="offerList.length > 0">
            <v-layout wrap justify-start v-if="offerList.length > 0">
              <v-flex v-for="(item, i) in offerList" :key="i" md6 pa-4>
                <v-card style="line-height: 16px">
                  <v-layout wrap pa-3>
                    <v-flex md4 px-2 style="border: 3px solid grey">
                      <img
                        v-if="item.photo"
                        v-viewer
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        :src="baseURL + '/file/get/' + item.photo"
                        height="180px"
                      />
                      <v-img
                        v-else
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        src="../../assets/images/no-image.png"
                        height="180px"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#FF2323"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex md8>
                      <v-layout wrap justify-left text-left px-2>
                        <v-flex xs12 pt-4>
                          <span
                            style="
                              font-size: 18px;
                              color: #000000;
                              font-weight: bold;
                            "
                          >
                            {{ item.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            style="
                              font-size: 12px;
                              color: #000000;
                              font-weight: bold;
                            "
                            v-html="item.description"
                          >
                          </span>
                        </v-flex>
                        <v-flex pr-3>
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <span style="font-size: 12px; color: #000000"
                            >Offer validity:</span
                          >
                          <br />
                          <span
                            class="showLine"
                            style="font-size: 13px; color: #000000"
                          >
                            <span style="font-weight: bold">
                              {{ formatDate(item.starting) }}
                              {{ formatTime(item.startingTime) }} to
                              {{ formatDate(item.ending) }}
                              {{ formatTime(item.endingTime) }}
                            </span>
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            v-if="item.categoryId"
                            style="font-size: 12px; color: #000000"
                          >
                            Category: {{ item.categoryId.name }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            v-if="item.SubcategoryId"
                            style="font-size: 12px; color: #000000"
                          >
                            Sub Category: {{ item.SubcategoryId.name }}
                          </span>
                        </v-flex>
                        <v-flex
                          xs12
                          pt-1
                          v-if="$route.query.Type == 'ProductBanner'"
                        >
                          <span style="font-size: 12px; color: #000000">
                            Products: {{ item.productId.name }}
                          </span>
                        </v-flex>
                        <br />
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout text-right>
                        <v-flex pt-2 px-1 xs12 align-self-end>
                          <v-dialog v-model="item.delete" max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                class="mr-2"
                                outlined
                                block
                                v-on="on"
                                v-bind="attrs"
                                color="red"
                              >
                                Delete
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title
                                >Are you sure you want to delete this
                                Banner?</v-card-title
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="item.delete = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="deleteItem(item)"
                                  >OK</v-btn
                                >
                                <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                        <!-- <v-flex pt-2 px-1 xs6 align-self-end>
                          <v-btn
                            x-small
                            class="mr-2"
                            outlined
                            block
                            color="green"
                            @click="editSlider(item)"
                          >
                            Edit
                          </v-btn>
                        </v-flex> -->
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <v-layout pt-15 justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span style="font-size: 22px; letter-spacing: 1px">
                  No Data Found...
                </span>
              </v-flex>
            </v-layout>
          </div>
          <v-dialog v-model="editdialog" max-width="800px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit Banner</span>
              </v-card-title>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Banner Name"
                      v-model="editingitem.name"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 v-if="$route.query.Type == 'ProductBanner'">
                    <v-autocomplete
                      item-text="varientName"
                      item-value="productId._id"
                      label="Product List"
                      v-model="editingitem.productId"
                      :items="productList"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <!-- {{editingitem.categoryId}} -->
                    <v-autocomplete
                      v-model="editingitem.categoryId"
                      :items="categoryList"
                      @change="getProduct(editingitem.categoryId)"
                      :rules="[rules.required]"
                      item-text="name"
                      item-value="_id"
                      color="#B1B1B1"
                      hide-details
                      placeholder="Category"
                      label="Category"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6 pl-0 pl-sm-4>
                    <v-autocomplete
                      v-model="editingitem.subcategoryId"
                      :items="products"
                      item-text="name"
                      item-value="_id"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <span class="homeText">Description of the Offer</span>
                    <div id="app" class="pt-3">
                      <vue-editor
                        v-model="editingitem.description"
                      ></vue-editor>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout wrap pt-3>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu5"
                      v-model="menu5"
                      :close-on-content-click="false"
                      :return-value.sync="editingitem.startingDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.startingDate"
                          label="Select Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editingitem.startingDate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu5 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu5.save(editingitem.startingDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu6"
                      v-model="menu6"
                      :close-on-content-click="false"
                      :return-value.sync="editingitem.endingDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.endingDate"
                          label="Select Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editingitem.endingDate"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu6 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu6.save(editingitem.endingDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout wrap pt-3>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu8"
                      v-model="menu8"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editingitem.startingTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.startingTime"
                          :rules="[rules.required]"
                          label="Starting Time"
                          prepend-icon="mdi-clock"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ampm-in-title
                        v-if="menu8"
                        v-model="editingitem.startingTime"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu8 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu8.save(editingitem.startingTime)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-menu
                      ref="menu7"
                      v-model="menu7"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editingitem.endingTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editingitem.endingTime"
                          :rules="[rules.required]"
                          prepend-icon="mdi-clock"
                          label="Ending Time"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        ampm-in-title
                        v-if="menu7"
                        v-model="editingitem.endingTime"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu7 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu7.save(editingitem.endingTime)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 md12 lg12>
                    <ImageComp
                      :singleImage="editingitem.photo"
                      :pageId="editingitem._id"
                      @stepper="winStepper"
                      :height="$route.query.Type == 'SmallBanner'? '3':'9'"
                      :width="$route.query.Type == 'SmallBanner'? '16':'16'"
                      :heading="'Upload offer Image (Aspect Ratio: 16/9)'"
                      :componentType="'offerImage'"
                    />
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="editdialog = false">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="edit()"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
        <div class="text-center pb-5">
          <v-pagination
            :length="pages"
            :total-visible="8"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ImageComp from "@/components/Common/singleImage";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
    ImageComp,
  },
  data() {
    return {
      productList: [],
      ServerError: false,
      widthOfCard: "250px",
      rot: 0,
      menu: false,
      menu1: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      products: [],
      offerData: {
        categoryId: null,
        subcategoryId: null,
        name: null,
        userid: null,
        startingDate: new Date().toISOString().substr(0, 10),
        endingDate: new Date().toISOString().substr(0, 10),
        startingTime: null,
        endingTime: null,
        offerType: "product",
        productId: null,
      },

      formDataCover: new FormData(),
      offerImage: null,
      showSnackbar: false,
      msg: null,
      pages: 0,
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      delete: false,
      dialogDelete: false,
      dialog: false,
      dialog1: false,
      editdialog: false,
      editingitem: [],
      offerList: [],
      data: [],
      addslider: false,
      imgId: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },
      Rules: [(value) => !!value || "Required."],
      titleRule: [(v) => v.length < 50 || "Min 50 characters"],
      sellers: [],
      categoryList: [],
    };
  },

  mounted() {
    this.getData();
    this.getCategory();
    this.getProducts();
  },
  // watch: {
  //   rot() {
  //     if (this.rot > 360) this.rot = 0;
  //   },
  // },
  methods: {
    getProduct(sellerId) {
      console.log(sellerId);
      this.appLoading = true;

      axios({
        url: "/grocery/subcategory/list/" + sellerId,
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      if (window_data.type == "offerImage") {
        this.offerImage = window_data.selectedFiles;
      }
      if (window_data.type == "offerCoverImage") {
        this.offerCoverImage = window_data.selectedFiles;
      }
    },
    getData() {
      let getURL;
      if (this.$route.query.Type == "MainBanner") {
        getURL = "/grocery/admin/category/banner/list";
      } else if (this.$route.query.Type == "SmallBanner") {
        getURL = "/grocery/admin/small/banner/list";
      } else if (this.$route.query.Type == "ProductBanner") {
        getURL = "/grocery/admin/product/banner/list";
      } else {
        getURL = "/grocery/admin/bottam/banner/list";
      }

      this.appLoading = true;
      axios({
        url: getURL,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          count: this.count,
          page: this.currentPage,
          offerType: "product",
        },
      })
        .then((response) => {
          this.offerList = response.data.data;

          this.pages = response.data.totalPages;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getProducts() {
      // this.appLoading = true;
      axios({
        method: "post",
        url: "/grocery/admin/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.productList = response.data.product;

              // this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getCategory() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/grocery/category/list/62b16b36fdd907192c69f476",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.categoryList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    add() {
      this.appLoading = true;

      let getURL;
      if (this.$route.query.Type == "MainBanner") {
        getURL = "/grocery/admin/category/banner/add";
      } else if (this.$route.query.Type == "SmallBanner") {
        getURL = "/grocery/admin/small/banner/add";
      } else if (this.$route.query.Type == "ProductBanner") {
        getURL = "/grocery/admin/product/banner/add";
      } else {
        getURL = "/grocery/admin/bottam/banner/add";
      }
      axios({
        url: getURL,
        method: "POST",
        data: this.offerData,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.imgId = response.data.id;
            if (this.offerImage) this.uploadImage(response.data.id);
            this.getData();
            this.msg = "Added Sucessfully";
            this.showSnackbar = true;
            Object.keys(this.offerData).forEach(
              (key) => (this.offerData[key] = null)
            );
            this.link = null;
            this.title = null;
            this.caption = null;
            this.date = null;
            this.imagePreview = null;
            this.file = null;
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      let getURL;
      if (this.$route.query.Type == "MainBanner") {
        getURL = "/grocery/admin/category/banner/edit";
      } else if (this.$route.query.Type == "SmallBanner") {
        getURL = "/grocery/admin/small/banner/edit";
      } else if (this.$route.query.Type == "ProductBanner") {
        getURL = "/grocery/admin/product/banner/edit";
      } else {
        getURL = "/grocery/admin/bottom/banner/edit";
      }
      this.appLoading = true;
      //   this.formDataCover.append("userid", this.editingitem.seller);
      //   this.formDataCover.append("name", this.editingitem.name);
      this.formDataCover.append("name", this.editingitem.name);
      this.formDataCover.append("categoryId", this.editingitem.categoryId);

      if (this.editingitem.subcategoryId) {
        this.formDataCover.append(
          "subcategoryId",
          this.editingitem.subcategoryId
        );
      }
      //////////////////////////////////////////////////////////////////////////////
      this.formDataCover.append("description", this.editingitem.description);
      this.formDataCover.append("startingDate", this.editingitem.startingDate);
      this.formDataCover.append("startingTime", this.editingitem.startingTime);
      this.formDataCover.append("endingDate", this.editingitem.endingDate);
      this.formDataCover.append("endingTime", this.editingitem.endingTime);
      this.formDataCover.append("photo", this.offerImage);
      this.formDataCover.append("id", this.editingitem._id);
      axios({
        method: "POST",
        url: getURL,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.formDataCover,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.formDataCover = new FormData();
            this.msg = response.data.msg;
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
            this.formDataCover = new FormData();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editSlider(item) {
      this.editingitem = item;
      if (this.editingitem.sellerId) {
        this.editingitem.seller = item.sellerId.uid;
        this.getProduct(item.sellerId.uid);
      }
      if (this.editingitem.productId)
        this.editingitem.product = item.productId._id;
      // this.editingitem.startingDate = this.editingitem.starting.slice(0, 10);
      // this.editingitem.endingDate = this.editingitem.ending.slice(0, 10);
      // this.editingitem.startingTime = this.editingitem.starting.slice(11, 16);
      // this.editingitem.endingTime = this.editingitem.ending.slice(11, 16);
      this.editdialog = true;
    },
    deleteItem(r) {
      let getURL;
      if (this.$route.query.Type == "MainBanner") {
        getURL = "/grocery/category/banner/delete";
      } else if (this.$route.query.Type == "SmallBanner") {
        getURL = "/grocery/small/banner/delete";
      } else if (this.$route.query.Type == "ProductBanner") {
        getURL = "/grocery/product/banner/delete";
      } else {
        getURL = "/grocery/bottam/banner/delete";
      }
      this.appLoading = true;
      axios({
        url: getURL,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: r._id,
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },

    uploadImage(id) {
      let getURL;
      if (this.$route.query.Type == "MainBanner") {
        getURL = "/grocery/admin/category/banner/edit";
      } else if (this.$route.query.Type == "SmallBanner") {
        getURL = "/grocery/admin/small/banner/edit";
      } else if (this.$route.query.Type == "ProductBanner") {
        getURL = "/grocery/admin/product/banner/edit";
      } else {
        getURL = "/grocery/admin/bottom/banner/edit";
      }

      let formData = new FormData();
      formData.append("id", id);
      formData.append("photo", this.offerImage);

      axios({
        method: "POST",
        url: getURL,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.offerImage = null;

            this.showSnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>